<div class="prompt-content">
  <img class="prompt-content--logo" src="assets/images/logo.png" alt="Site Logo" />
  <h1 mat-dialog-title>{{ 'The app needs to be updated' | translate }}</h1>
  <div mat-dialog-content class="dialog-content notice-container">
    <div class="notice-container">
      @if (platform === 'ios') {
        <p>{{ 'Please download the newest version from the App Store.' | translate }}</p>
      }
      @if (platform === 'android') {
        <p>{{ 'Please download the newest version from Google Play.' | translate }}
        </p>
      }
    </div>
    <div>
      <a (click)="openStoreLink()" class="prompt-content--store-image">
        @if (platform === 'ios') {
          <img src="assets/images/app-ios.png" alt="Download on the App Store">
        }
        @if (platform === 'android') {
          <img src="assets/images/app-android.png" alt="Get it on Google Play">
        }
      </a>
    </div>
  </div>
</div>